var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 20.3L18 16.6C19.2 15.1 20 13.1 20 11C20 6 16 2 11 2C6 2 2 6 2 11C2 16 6 20 11 20C13.1 20 15.1 19.3 16.6 18L20.3 21.7C20.5 21.9 20.8 22 21 22C21.2 22 21.5 21.9 21.7 21.7C22.1 21.3 22.1 20.7 21.7 20.3ZM4 11C4 7.1 7.1 4 11 4C14.9 4 18 7.1 18 11C18 12.8 17.3 14.5 16.2 15.7C16.1 15.7 16 15.8 15.9 15.9C15.8 16 15.8 16.1 15.7 16.2C14.5 17.3 12.8 18 11 18C7.1 18 4 14.9 4 11Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconSearch.bbde9b782837e134b0abf9f2fed46495.svg";